export default {
  namespaced: true,
  traffic: {
    title: "traffic",
    counter: "contador",
    reset: "reiniciar contador",
    request: "petición",
    created: "primera conexión",
    imei: "imei",
    ip: "ip",
    alarm: "alarma",
    with_counter: "tráfico con contadores",
    without_counter: "tráfico sin contadores",
    updatedAt: "última actualización"
  },
};
